import { useFormContext } from "react-hook-form"
import { useTranslation } from "react-i18next"
import { DetailCheckbox } from "@/components/ui/checkbox"
import { FormField } from "@/components/ui/form"
import { TranslatedFieldError } from "@/components/ui/form-field-error"
import { TreatmentForm } from "@/modules/admin/treatment/schema/treatment-form-schema"
import { CountryValues } from "@/types/__generated__/union-types"

const TreatmentPlanTemplatesSectionCountryForm = () => {
  const { t } = useTranslation()

  const form = useFormContext<TreatmentForm>()

  const {
    control,
    formState: { errors },
  } = form

  return (
    <>
      <div className="text-on-surface-subdued col-span-4 text-sm font-medium">
        <label>{t("admin.treatment.form.country")}</label>
      </div>
      <div className="flex flex-wrap gap-2">
        {CountryValues.map((field) => (
          <FormField
            key={field}
            control={control}
            name={"countries"}
            render={({ field: { onChange, value = [] } }) => {
              return (
                <DetailCheckbox
                  testId={`country-${field.toLowerCase()}`}
                  checked={value.includes(field)}
                  onCheckedChange={(checked) => {
                    const checkedValues = checked
                      ? [...value, field].sort((a, b) => a.localeCompare(b))
                      : value.filter((value) => value !== field)
                    onChange(checkedValues)
                  }}>
                  {field}
                </DetailCheckbox>
              )
            }}
          />
        ))}
        {errors.countries && (
          <TranslatedFieldError message={errors.countries?.message} errors={errors} name="countries" />
        )}
      </div>
    </>
  )
}

export { TreatmentPlanTemplatesSectionCountryForm }
